import axios from "axios";
import { User } from "../contexts/UserContext";

const exportViewers = [
  "agoldstein@madisoncres.com",
  "sdavidowitz@madisoncres.com",
  "tnewman@madisoncres.com",
  "gmargareten@madisoncres.com",
  "bfishman@madisoncres.com",
  "mbecker@madisoncres.com",
  "bsputz@madisoncres.com"
];

export const isContactExportViewer = (user: User | null) => {
  return exportViewers.includes(user?.email?.toLowerCase() || "");
};

export const downloadVcfByContactIds = async (contactIds: number[], fileName?: string) => {
  try {
    const response = await axios.post(
      "/api/clientphonebook/contacts/generateVcfByContactIds",
      { contactIds },
      {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName || "contacts.vcf");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Failed to download VCF:", error);
    alert("Something went wrong while downloading the file.");
  }
};

export const addToExportList = async (contactId: number) => {
  const { data } = await axios.post<boolean>(`/api/clientphonebook/contacts/addToContactExports`, { contactId });
  return data;
};

export const markContactsAsExported = async (contactIds: number[]) => {
  const data = await axios.post(`/api/clientphonebook/contacts/markContactsAsExported`, { contactIds });
};

export const getTodaysExportContactIds = async (): Promise<number[]> => {
  const { data } = await axios.get(`/api/clientphonebook/contacts/getTodaysExportContactIdsForUser`);
  return data;
};

export const downloadExportList = async () => {
  try {
    const contactIds = await getTodaysExportContactIds();

    if (!contactIds || contactIds.length === 0) {
      alert("No contacts found for today's export list.");
      return;
    }

    const response = await axios.post(
      "/api/clientphonebook/contacts/generateVcfByContactIds",
      { contactIds },
      {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `exports_${new Date().toISOString().split("T")[0]}.vcf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    await markContactsAsExported(contactIds);
  } catch (error) {
    console.error("Failed to download export list:", error);
    alert("Something went wrong while downloading the export list.");
  }
};
